import { FetchResult, MutationFunctionOptions } from "@apollo/client";
import _ from "lodash";
import React from "react";
import { FlexGrow, FlexRowStretch } from "../flex/Flex";
import {
  InputFormBuilder,
  InputFormBuilderProperties,
} from "./InputFormBuilder";

export enum InputFormMode {
  Create,
  Edit,
}

export interface UpdateStateHelper<T> {
  item?: T;
  open: boolean;
}

export interface ValuesVariables<T> {
  values: Partial<T>;
}

export interface CreateVariables<T> {
  values: T;
}

export type Mutation<MutationType, MutationVariables> = (
  options?: MutationFunctionOptions<MutationType, MutationVariables>
) => Promise<FetchResult<MutationType>>;

export interface InputFormState<ObjectType> {
  random_id: string;
  values: Partial<ObjectType>;
  submitting: boolean;
  changed: boolean;
  success: boolean;
  error: any | null;
  scratch_pad: any;
  original_input?: ObjectType;
  changes?: (v: boolean) => void;
}

export const isDifferent = (a: any, b: any) =>
  _.find(a, (value, key) => !_.isEqual(_.get(b, key), value)) ||
  _.find(b, (value, key) => !_.isEqual(_.get(a, key), value));

export type InputFormProps<ObjectType, MutationResponse, MutationVariable> =
  Omit<
    InputFormBuilderProperties<ObjectType, MutationResponse, MutationVariable>,
    "children"
  >;

export class InputForm<
  ObjectType = any,
  MutationResponse = any,
  MutationVariable = any
> extends React.PureComponent<
  InputFormProps<ObjectType, MutationResponse, MutationVariable>
> {
  render() {
    return (
      <InputFormBuilder<ObjectType, MutationResponse, MutationVariable>
        {...this.props}
      >
        {(builder) => {
          return (
            <div>
              {_.map(this.props.keys, (__, key) =>
                builder.buildField(key as keyof ObjectType)
              )}
              <FlexRowStretch>
                <FlexGrow />
                {builder.buildSubmitButton()}
              </FlexRowStretch>
            </div>
          );
        }}
      </InputFormBuilder>
    );
  }
}
